<div
  class="hq-loan-banner color-white flex align_center"
  [ngStyle]="{ 'background-image': backgroundImage }"
  *ngIf="isAdminEnable"
>
  <span>
    <span class="fw-600 fs-20 instant-loan">
     {{'ORDER_DASHBOARD.INSTANT_LOAN' | fallbackTranslate}} <span class="fs-24 fw-700">60,000*</span> {{'ORDER_DASHBOARD.AVAILABLE' | fallbackTranslate}}
    </span>
    <span class="fs-16 fw-600 check-outlet-row">
      {{'ORDER_DASHBOARD.CHECK_OUTLET' | fallbackTranslate}}
      <span class="m-b-12">
        <i nz-icon nzType="info-circle" nzTheme="outline" class="info m-l-4" 
        nzTooltipTitle="{{'ORDER_DASHBOARD.LOAN_TOOLTIP' | fallbackTranslate}}" nzTooltipPlacement="left" nz-tooltip></i>
      </span>
    </span>
  </span>
  <button class="banner-close c-pointer">
    <img
      [src]="images?.CLOSE_TRANSPARENT"
      alt="cross"
      class="img img-24"
      (click)="closeBanner()"
    />
  </button>
</div>